import React from 'react';
import { Tab, Segment, Header, Grid, Icon, Popup } from 'semantic-ui-react';
import StudentRecognitionDetails from './StudentRecognitionDetails';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import RecognizedExams from './RecognizedExams';
import { ToastContainer } from 'react-toastify';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { FormattedMessage } from 'react-intl';


export default class StudentsTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            studentsInfo: JSON.parse(localStorage.getItem('studentsInfo')),
            newStudyProgram: JSON.parse(localStorage.getItem('newStudyProgram')),
        };
    }
    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
    }

    render() {
        const panes = [
            {
                menuItem: 'Osnovni podaci',
                render: () => (<Tab.Pane attached={false} responsive={Responsive} >
                    <StudentRecognitionDetails />
                </Tab.Pane>),
            },
            {
                menuItem: 'Predmeti',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    <RecognizedExams></RecognizedExams>
                </Tab.Pane>),
            },

        ];
        return (
            <div>
                <h1> Priznavanje ispita </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    {this.state.student.firstName} {this.state.student.lastName}
                                    <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Popup
                                            trigger={<Icon
                                                link
                                                circular
                                                basic="true"
                                                floated="right"
                                                name="arrow left"
                                                onClick={() => window.history.go(-1)}
                                            />}
                                            content={<FormattedMessage id="common.back" />}
                                            hideOnScroll
                                            position="top center"
                                        />
                                    </Header>
                                    <Header.Subheader floated="left">
                                        Ime i prezime studenta/ice
                                    </Header.Subheader>
                                </Header>
                            </Segment>
                            <Segment>
                                 <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                            </Segment>
                            <ToastContainer hideProgressBar />
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/StudentsTab.js